import { SVG_ICONS } from "../components/TablerIconPicker";

// Validate icon exists before use
export const getIcon = (iconId, defaultIcon = "circle") => {
  if (!SVG_ICONS[iconId]) {
    console.warn(`Icon "${iconId}" not found. Using fallback "${defaultIcon}"`);
    return SVG_ICONS[defaultIcon] || SVG_ICONS["circle"];
  }
  return SVG_ICONS[iconId];
};

// Get list of available icons for reference
export const getAvailableIcons = () => {
  return Object.keys(SVG_ICONS);
};
